<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-risk-codes-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-panel
          :column-defs="columnDefs"
          height="xl"
          :url="() => this.$api.riskCode.list()"
          :auto-size="true"
          @rowClicked="edit"
          title="Risk Codes"
      >
        <vs-dropdown-item v-if="componentAccess.canCreate.access">
          <span
              class="flex items-center"
              @click="$router.push({ name: 'risk-codes.create' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create Risk Code</span>
          </span>
        </vs-dropdown-item>
      </grid-panel>

    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import CellMatchingMixin from "@/views/pages/sync/CellMatchingMixin";
import GridPanel from "@/views/components/ag-grid/GridPanel";

export default {
  components: {
    TGrid,
    GridPanel,
  },
  mixins: [CellMatchingMixin,CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,
      componentAccess: {
        canCreate: {
          route: 'risk-codes.create',
          access: false,
        },
      },

      // AgGrid
      columnDefs: [
        {
          headerName: 'Risk Code',
          field: 'RiskCodeText',
          filter: 'agTextColumnFilter',
          maxWidth: 150,
        },
        {
          headerName: 'Description',
          field: 'RiskCodeDescription',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Reference One',
          field: 'One',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Reference Two',
          field: 'Two',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Reference Three',
          field: 'Three',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Reference Four',
          field: 'Four',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Reference Description Four',
          field: 'RiskCodeDescriptionFour',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Reference Five',
          field: 'Five',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Reference Six',
          field: 'Six',
          filter: 'agTextColumnFilter',
        },
        {
          headerName: 'Reference Description Six',
          field: 'RiskCodeDescriptionSix',
          filter: 'agTextColumnFilter',
        },
      ],
    }
  },
  methods: {
    edit({data}) {
      this.$router.push({ name: 'risk-codes.view', params: { id: data.id }}).catch(() => {});
    }
  },
}

</script>

<style lang="scss">
</style>
